/* tslint:disable */
/* eslint-disable */
/**
 * FastAPI
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { ProblemType } from './ProblemType';
import {
    ProblemTypeFromJSON,
    ProblemTypeFromJSONTyped,
    ProblemTypeToJSON,
    ProblemTypeToJSONTyped,
} from './ProblemType';
import type { CompetitionSummary } from './CompetitionSummary';
import {
    CompetitionSummaryFromJSON,
    CompetitionSummaryFromJSONTyped,
    CompetitionSummaryToJSON,
    CompetitionSummaryToJSONTyped,
} from './CompetitionSummary';

/**
 * Schema for reading workshop-problem association, enriched with problem details.
 * @export
 * @interface WorkshopProblemRead
 */
export interface WorkshopProblemRead {
    /**
     * 
     * @type {string}
     * @memberof WorkshopProblemRead
     */
    problem_id: string;
    /**
     * 
     * @type {string}
     * @memberof WorkshopProblemRead
     */
    problem_name?: string | null;
    /**
     * 
     * @type {number}
     * @memberof WorkshopProblemRead
     */
    order: number;
    /**
     * 
     * @type {number}
     * @memberof WorkshopProblemRead
     */
    points?: number | null;
    /**
     * 
     * @type {number}
     * @memberof WorkshopProblemRead
     */
    complexity?: number | null;
    /**
     * 
     * @type {ProblemType}
     * @memberof WorkshopProblemRead
     */
    problem_type?: ProblemType | null;
    /**
     * 
     * @type {number}
     * @memberof WorkshopProblemRead
     */
    time_limit?: number | null;
    /**
     * 
     * @type {Array<CompetitionSummary>}
     * @memberof WorkshopProblemRead
     */
    competitions?: Array<CompetitionSummary>;
}



/**
 * Check if a given object implements the WorkshopProblemRead interface.
 */
export function instanceOfWorkshopProblemRead(value: object): value is WorkshopProblemRead {
    if (!('problem_id' in value) || value['problem_id'] === undefined) return false;
    if (!('order' in value) || value['order'] === undefined) return false;
    return true;
}

export function WorkshopProblemReadFromJSON(json: any): WorkshopProblemRead {
    return WorkshopProblemReadFromJSONTyped(json, false);
}

export function WorkshopProblemReadFromJSONTyped(json: any, ignoreDiscriminator: boolean): WorkshopProblemRead {
    if (json == null) {
        return json;
    }
    return {
        
        'problem_id': json['problem_id'],
        'problem_name': json['problem_name'] == null ? undefined : json['problem_name'],
        'order': json['order'],
        'points': json['points'] == null ? undefined : json['points'],
        'complexity': json['complexity'] == null ? undefined : json['complexity'],
        'problem_type': json['problem_type'] == null ? undefined : ProblemTypeFromJSON(json['problem_type']),
        'time_limit': json['time_limit'] == null ? undefined : json['time_limit'],
        'competitions': json['competitions'] == null ? undefined : ((json['competitions'] as Array<any>).map(CompetitionSummaryFromJSON)),
    };
}

export function WorkshopProblemReadToJSON(json: any): WorkshopProblemRead {
    return WorkshopProblemReadToJSONTyped(json, false);
}

export function WorkshopProblemReadToJSONTyped(value?: WorkshopProblemRead | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'problem_id': value['problem_id'],
        'problem_name': value['problem_name'],
        'order': value['order'],
        'points': value['points'],
        'complexity': value['complexity'],
        'problem_type': ProblemTypeToJSON(value['problem_type']),
        'time_limit': value['time_limit'],
        'competitions': value['competitions'] == null ? undefined : ((value['competitions'] as Array<any>).map(CompetitionSummaryToJSON)),
    };
}

